import {
    AlertText,
    AlertTextWrapper,
    AlertWrapper,
} from '@/src/common/components/elements/Alerts/StyledComponents'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const KYCFlowMaxErrors = ({
    style = {},
}: {
    style?: object
}) => {
    return (
        <AlertWrapper variant={'error'} style={style}>
            <FontAwesomeIcon icon={faExclamationTriangle} />
            <AlertTextWrapper>
                <AlertText>
                    Your total gift card load value cannot be larger than $10,000 and/or 
                    a quantity greater than 50 cards.  You will instead
                    need to complete your order through{' '}
                    <a href={'/corporate/get-started?variant=default'}>PerfectGift Corporate</a>
                </AlertText>
            </AlertTextWrapper>
        </AlertWrapper>
    )
}

export default KYCFlowMaxErrors
